import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import Field from '#client/components/Field';

import useAddress2Field from './useAddress2Field';

function Address2Field({ helperText, namePrefix, validation, ...delegated }) {
  const { error, field } = useAddress2Field({ namePrefix, validation });

  return (
    <Field
      {...field}
      error={error}
      helperText={helperText || error?.message}
      inputProps={{
        autoComplete: 'address-line2',
        'data-testid': 'address-line2'
      }}
      label={<FormattedMessage id="shopping.component.addressFieldset.address2Field.label" />}
      {...delegated}
    />
  );
}

Address2Field.propTypes = {
  helperText: PropTypes.string,
  namePrefix: PropTypes.string,
  validation: PropTypes.object
};

export default Address2Field;
